const texts = {
    notFound:'Pide permiso para tener algún rol.',
  };
  
  export default texts;